import type { RacePageDTO } from '@mobi/api-types'
import dayjs from '@mobi/utils/date/extendedDayjs'
import { get } from '@classic/Foundation/Services/ApiService'

export const getRacePageDataFromApi = async (
  meetingId: string,
  meetingDate: Date | string,
  raceNumber: number
): Promise<RacePageDTO> => {
  const url = getCompleteRaceApiUrl(meetingId.toLowerCase(), meetingDate, raceNumber)
  const response = await get<RacePageDTO>({ url })
  return response
}

function getCompleteRaceApiUrl(meetingId: string, meetingDate: Date | string, raceNumber: number) {
  const formattedDate = dayjs(meetingDate).format('YYYY-MM-DD')
  const url = `/api/meetings/${meetingId}/${formattedDate}/race/${raceNumber}`
  return (url + '?includeSrm').toLowerCase()
}
